import onResize from '../utils/onResize';

const headerScrollingClass = 'header-container--scrolled';
const headerShadowClass = 'shadow-navigation';

function detectIsTopChange(header) {
    const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    // If Screen size is desktop (> 1137) then add toggle the color when scrolling
    if (screenWidth > 1137) {
        if (header.offsetTop !== 0) {
            requestAnimationFrame(() => header.classList.add(headerScrollingClass, headerShadowClass));
        } else {
            requestAnimationFrame(() => header.classList.remove(headerScrollingClass, headerShadowClass));
        }
        // Else if Screen size is on tablet (< 1024) then make sure reset the color of the header
    } else {
        requestAnimationFrame(() => header.classList.remove(headerScrollingClass, headerShadowClass));
    }
}

export default function init(elements) {
    elements.forEach(el => {
        window.addEventListener('scroll', () => detectIsTopChange(el));
        onResize(() => detectIsTopChange(el));
    });
}
